import axios from './Axios';
import { error, success } from "./ResponseHandler";
import GLOBAL from "../global";

const RESPONSE_TYPE = { responseType: 'text' };
const { REACT_APP_BASE_API_URL, REACT_APP_VA_API_URL } = process.env;
const DOCUMENT_TYPES_URL = REACT_APP_BASE_API_URL + "/api/document/getDocumentTypes";
const DOCUMENTS_URL = REACT_APP_BASE_API_URL + "/api/document/getDocuments";
const ADD_DOCUMENT_URL = REACT_APP_BASE_API_URL + "/api/document/addDocument";
const DELETE_DOCUMENT_URL = REACT_APP_BASE_API_URL + "/api/document/deleteDocument";
const DOWNLOAD_DOCUMENT_URL = REACT_APP_BASE_API_URL + "/api/document/download";
const BASE64_TO_URL_URL = REACT_APP_VA_API_URL + "/ReportApi/UploadFileToCdn";

class DocumentService {
    async getDocumentTypes() {
        try {
            const payload = {};
            const response = await axios.post(DOCUMENT_TYPES_URL, payload, RESPONSE_TYPE);

            return success(response);
        } catch (e) {
            return error(e);
        }
    }

    async getDocuments(payload) {
        try {
            const response = await axios.post(DOCUMENTS_URL, payload, RESPONSE_TYPE);

            return success(response);
        } catch (e) {
            return error(e);
        }
    }

    async addDocument(payload = {}) {
        try {
            const response = await axios.post(ADD_DOCUMENT_URL, payload, RESPONSE_TYPE);

            return success(response);
        } catch (e) {
            return error(e);
        }
    }

    async deleteDocument(payload = {}) {
        try {
            const response = await axios.post(DELETE_DOCUMENT_URL, payload, RESPONSE_TYPE);

            return success(response);
        } catch (e) {
            return error(e);
        }
    }

    async download(payload = {}) {
        try {
            const response = await axios.post(DOWNLOAD_DOCUMENT_URL, payload, RESPONSE_TYPE);

            return success(response);
        } catch (e) {
            return error(e);
        }
    }

    async base64FileToUrl(payload = {}) {
        try {
            payload.Tenant = GLOBAL.TENANT;//VA PORTAL
            const response = await axios.post(BASE64_TO_URL_URL, payload, RESPONSE_TYPE);

            return success({ data: response });
        } catch (e) {
            return error(e);
        }
    }
}

export default new DocumentService();
